/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OwnersControllerFindOneQueryResponse, OwnersControllerFindOnePathParams, OwnersControllerFindOneQueryParams, OwnersControllerFindOne400, OwnersControllerFindOne401, OwnersControllerFindOne403, OwnersControllerFindOne404 } from "../../models/ownersController/OwnersControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ownersControllerFindOne } from "../../clients/ownersService/ownersControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ownersControllerFindOneQueryKey = (id: OwnersControllerFindOnePathParams["id"], params: OwnersControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/owners/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type OwnersControllerFindOneQueryKey = ReturnType<typeof ownersControllerFindOneQueryKey>;
export function ownersControllerFindOneQueryOptions(id: OwnersControllerFindOnePathParams["id"], params?: OwnersControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ownersControllerFindOneQueryKey(id, params);
  return queryOptions<OwnersControllerFindOneQueryResponse, ResponseErrorConfig<OwnersControllerFindOne400 | OwnersControllerFindOne401 | OwnersControllerFindOne403 | OwnersControllerFindOne404>, OwnersControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ownersControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get an owner by ID
 * {@link /api/v1/owners/:id}
 */
export function useOwnersControllerFindOne<TData = OwnersControllerFindOneQueryResponse, TQueryData = OwnersControllerFindOneQueryResponse, TQueryKey extends QueryKey = OwnersControllerFindOneQueryKey>(id: OwnersControllerFindOnePathParams["id"], params?: OwnersControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<OwnersControllerFindOneQueryResponse, ResponseErrorConfig<OwnersControllerFindOne400 | OwnersControllerFindOne401 | OwnersControllerFindOne403 | OwnersControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ownersControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...ownersControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<OwnersControllerFindOne400 | OwnersControllerFindOne401 | OwnersControllerFindOne403 | OwnersControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}